import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal as RBModal } from "react-bootstrap";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  Select,
  DatePicker,
  Input,
} from "../../components";
import { axios, Constants, Globals, ENV } from "../../utils";
import moment from 'moment';
import PrinterIcon from '../../assets/icons/printer.png';
import FilterIcon from "../../assets/icons/icono_filtro.png";
import CloseIcon from "../../assets/icons/icono_cerrar.png";

const INITIAL_FORM = {
  since: "",
  until: "",
  search: "",
  status: "",
  type: ""
}

class ReportVisitPlanner extends React.Component {

  state = {
    header: [
        'Cliente',
        'Visita',
        'Vendedor',
        'Fecha',
        'Tipo visita',
        'Estatus',
        'Duración',
        'N° Pedidos',
        'Resultado',
        'Observaciones',
        'Prox. Visita',
    ],
    page: 1,
    last_page: 1,
    data: [],
    form: INITIAL_FORM,
    user_id: this.props.user.level_id === Constants.ROLE_ADMIN
      ? this.props.user.id
      : this.props.user.admin_id,
    visible: false,
    item: null,
    visible_route: false,
    showFilters: false,
    planned: {
      pending: 0,
      finish: 0,
      unfinish: 0,
      total: 0
    },
    unplanned: {
      pending: 0,
      finish: 0,
      unfinish: 0
    },
    list_status: [
      { value: Constants.VISIT_PLANNER_STATUS.PENDING, label: 'Pendiente' },
      { value: Constants.VISIT_PLANNER_STATUS.FINISH, label: 'Finalizada' },
      { value: Constants.VISIT_PLANNER_STATUS.FAILED, label: 'No Finalizada' }
    ],
    list_types: [
      { value: Constants.VISIT_PLANNER_TYPE.PLANNED, label: 'Planificada' },
      { value: Constants.VISIT_PLANNER_TYPE.UNPLANNED, label: 'No planificada' },
    ],
  };

  componentDidMount() {
    this.fetchData();
  };

  fetchData = (page = 1) => {
    let { form } = this.state;

    form.user_id = this.props.user.id;    

    axios
      .post("admin/visit-planners/report?page=" + page, {
        ...form,
        since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
        until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
      })
      .then(res => {
        this.setState({
          page,
          last_page: res.data.visit_planners.last_page,
          data: res.data.visit_planners.data,
          planned: res.data.planned || {
            pending: 0,
            finish: 0,
            unfinish: 0,
            total: 0
          },
          unplanned: res.data.unplanned || {
            pending: 0,
            finish: 0,
            unfinish: 0
          }
        });

        if (res.data.admin?.admin_functionalities?.map((i) => i.id).indexOf(Constants.ADMIN_FUNCTIONALITIES.VISIT_PLANNER) == -1) {
          this.props.history.replace('/');
        }
      })
      .catch(() => {
        Globals.showError();
      });
  };

  change = (value, target) => {
    this.setState({
      form: {
        ...this.state.form,
        [target]: value
      }
    });
  };

  cleanFilters = async () => {
    await this.setState(state => ({
      ...state,
      form: INITIAL_FORM,
    }));
    await this.fetchData();
  }

  view = (item) => {
    this.setState({
      visible: true,
      item
    });
  }

  viewRoute = (item) => {
    this.setState({
      visible_route: true,
      item
    });
  }

  close = () => {
    this.setState({
      visible: false,
      item: null
    });
  }

  closeRoute = () => {
    this.setState({
      visible_route: false,
      item: null
    });
  }

  print = (data) => {
    axios
      .post("admin/visit-planners/report/download", this.state.form)
      .then(res => {
        if(res.data.url_storage){
          //const url = res.data.url;
          const url = `${ENV.BasePublic}${res.data.url_storage}`;
          const win = window.open(url, "_blank");
          win.focus();
        }
        else{
          Globals.showError('Ha ocurrido un error');
        }
      })
      .catch(err => {
        Globals.showError();
      });
    
  };

  render() {
    const { planned, unplanned } = this.state;

    return (
      <Menu history={this.props.history}>
        {this.state.showFilters && (
          <RBModal
            tabIndex="0"
            size="lg"
            show
            onHide={() => this.setState({ showFilters: false })}
            backdropClassName="custom-modal-bd"
            contentClassName="custom-modal-content"
            visible
          >
            <RBModal.Body>
              <img
                src={CloseIcon}
                alt="Cerrar"
                className="close-btn"
                onClick={() => this.setState({ showFilters: false })}
              />

              <Filters
                form={this.state.form}
                statuses={this.state.list_status}
                types={this.state.list_types}
                minDate={ this.state.form.since ? moment(this.state.form.since).toDate() : null }
                maxDate={ this.state.form.until ? moment(this.state.form.until).toDate() : null }
                onSearch={async (filters, close = false) => {
                  await this.setState(s => ({ ...(close ? { showFilters: false } : {}), page: 1, form: { ...s.form, ...filters } }));
                  this.fetchData();
                }}
                onClose={() => this.setState({ showFilters: false })}
              />
            </RBModal.Body>
          </RBModal>
        )}

        <div id="visit-planner" className="new-reports" style={{ marginTop: '3.5rem' }}>
          <Table
            data={this.state.data.length}
            header={this.state.header}
            title={
              <section className="widget-totals inside container-totals" style={{ top: '-4rem' }}>
                <div className="container-total">
                  <p className="name">Visitas planificadas</p>
                  <div className="container-values">
                    <div className="item-value">
                      <p className="value">{ planned.total }</p>
                      <p className="label">Planificadas</p>
                    </div>
                    <div className="item-value">
                      <p className="value">{ planned.pending }</p>
                      <p className="label">Pendientes</p>
                    </div>
                    <div className="item-value">
                      <p className="value">{ planned.finish }</p>
                      <p className="label">Finalizadas</p>
                    </div>
                    <div className="item-value">
                      <p className="value">{ planned.unfinish }</p>
                      <p className="label">No finalizadas</p>
                    </div>
                  </div>
                </div>
                <div className="container-total">
                  <p className="name">Visitas no planificadas</p>
                  <div className="container-values">
                    <div className="item-value">
                      <p className="value">{ unplanned.pending }</p>
                      <p className="label">Pendientes</p>
                    </div>
                    <div className="item-value">
                      <p className="value">{ unplanned.finish }</p>
                      <p className="label">Finalizadas</p>
                    </div>
                    <div className="item-value">
                      <p className="value">{ unplanned.unfinish }</p>
                      <p className="label">No finalizadas</p>
                    </div>
                  </div>
                </div>
              </section>
            }
            right={
              <>
                <Button
                  title="Filtrar"
                  small="true"
                  onClick={() => this.setState({ showFilters: true })}
                >
                  <img src={FilterIcon} alt="Imprimir" />
                </Button>
                <Button
                  title="Imprimir"
                  small="true"
                  onClick={() => this.print()}
                >
                  <img src={PrinterIcon} style={{ width: 24 }} alt="Imprimir" />
                </Button>
              </>
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{ i.client?.name }</td>
                  <td>{ i.visit_planner?.type_text }</td>
                  <td>{ i.visit_planner?.seller?.name }</td>
                  <td>{ moment(i.visit_planner?.date).format('DD-MM-YYYY') }</td>
                  <td>{ i.visit_type?.name }</td>
                  <td>{ i.status_text }</td>
                  <td>{ i.working_time }</td>
                  <td>{ i.visit_planner?.orders_number_format ?? '' }</td>
                  <td>
                    { 
                      i.visit?.results?.map(i => i.name).join(', ')
                    }
                  </td>
                  <td>{ i?.visit?.comments }</td>
                  <td>{ i?.visit?.next_date ? moment(i?.visit?.next_date).format('DD-MM-YYYY') : '' }</td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={page => this.fetchData(page)}
          />

        </div>
      </Menu>
    );
  }
}

const Filters = ({ form, types, statuses, minDate, maxDate, onSearch }) => {
  const initialFilters = {
    since: '',
    until: '',
    search: '',
    type: '',
    status: '',
  };

  const searchTimeout = React.useRef(null);
  React.useEffect(() => {
    return () => {
      if (searchTimeout.current) clearTimeout(searchTimeout.current);
    };
  }, []);

  const [_form, setForm] = useState({
    since: !!form.since ? moment(form.since).toDate() : '',
    until: !!form.until ? moment(form.until).toDate() : '',
    search: form.search ?? '',
    type: form.type ?? '',
    status: form.status ?? '',
  });

  const autoFilter = (newForm, isText = false) => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    if (isText) {
      searchTimeout.current = setTimeout(() => {
        onSearch(newForm, false);
      }, 700);
    } else {
      onSearch(newForm, false);
    }
  };

  const onChange = (value, target, isText = false) => {
    setForm(s => {
      const next = { ...s, [target]: value };
      autoFilter(next, isText);
      return next;
    });
  }

  const reset = () => {
    setForm(initialFilters);
    onSearch(initialFilters, false);
  }

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0 1rem', padding: '1rem 2rem 0' }}>
        <div>
          <DatePicker
            color="white"
            label="Desde"
            className="filter"
            minDate={minDate}
            value={_form.since}
            onChange={value => onChange(value, 'since', false)}
          />
        </div>
        <div>
          <DatePicker
            color="white"
            label="Hasta"
            className="filter"
            maxDate={maxDate}
            value={_form.until}
            onChange={value => onChange(value, 'until', false)}
          />
        </div>
        <div>
          <Input
            color=" "
            label="Vendedor"
            placeholder="Escribir"
            className="filter"
            labelClass="filter"
            value={_form.search }
            onChange={e => onChange(e.target.value, 'search', true)}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Visita"
            className="filter"
            value={_form.type}
            onChange={e => onChange(e.target.value, 'type', false)}
            options={types}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Estatus"
            className="filter"
            value={_form.status}
            onChange={e => onChange(e.target.value, 'status', false)}
            options={statuses}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className="btn-align-bottom btn-filter"
          style={{ minWidth: 110, maxWidth: 110, marginRight: 0 }}
          color=" "
          onClick={reset}
        >
          <span>Limpiar</span>
        </Button>
      </div>
    </>
  )
}

export default connect(state => {
  return {
    user: state.user
  };
})(ReportVisitPlanner);
